import { combineReducers } from "redux";
import { AccidentQuestionReducer } from "./reducer-accident-questions";
import { couponsReducer } from "../features/Coupons";
import { warrantyDeflectionReducer } from "../features/WarrantyDeflection";
import { DropoffLocationSelectionReducer } from "../screens/DropoffLocationSelection/reducer";
import { EPCSReducer } from "./reducer-epcs-status";
import { FeatureFlagReducer } from "../features/FeatureFlags";
import { LicensePlateVinLookupReducer } from "./reducer-license-plate-vin-lookup";
import { LocationRouterReducer } from "../screens/LocationRouter/reducer";
import { NeedsTransportReducer } from "./reducer-needs-transport-questions";
import { ReplacementRentalCarReducer } from "./reducer-replacement-rental-car-questions";
import { predictiveETAReducer } from "./reducer-predictiveETA";
import chatbot from "./reducer-chatbot";
import commonBenefits from "./reducer-common-benefit";
import currentLocation from "./reducer-currentlocation";
import destination from "./reducer-destination";
import driverList from "./reducer-driver-list";
import userDetails from './reducer-user-details';
import epcsInitialize from "./reducer-epcs-initialize";
import generalInfo from "./reducer-general-info";
import incidentReportForm from "./reducer-incident-report-form";
import makeModel from "./reducer-makeModel";
import nearByDestinations from "./reducer-near-by-destinations";
import partnerDetails from "./reducer-partner-details";
import pepSession from "./reducer-pep-session";
import providerInfo from "./reducer-providerInfo";
import serviceDetails from "./reducer-service-details";
import serviceInfo from "./reducer-service-info";
import serviceRequestPayload from "./reducer-service-request-payload";
import serviceTime from "./reducer-service-time";
import serviceTransition from "./reducer-serviceTransition";
import submitRequest from "./reducer-submitrequest";
import vehicleValue from "./reducer-vehicle-value";
import readyToSubmitRescue from "./reducer-readyToSubmitRescue"
import { urlShortenerReducer } from "./reducer-urlShortener";

const baseReducer = combineReducers({
  accidentQuestions: AccidentQuestionReducer,
  chatbot,
  commonBenefits,
  couponsReducer,
  currentLocation,
  replacementRentalCar: ReplacementRentalCarReducer,
  needsTransport: NeedsTransportReducer,
  destination,
  driverList,
  userDetails,
  dropoffLocationSelection: DropoffLocationSelectionReducer,
  epcsInitialize,
  epcsStatus: EPCSReducer,
  featureFlag: FeatureFlagReducer,
  generalInfo,
  incidentReportForm,
  licensePlateVinLookup: LicensePlateVinLookupReducer,
  locationRouter: LocationRouterReducer,
  makeModel,
  nearByDestinations,
  partnerDetails,
  pepSession,
  providerInfo,
  serviceDetails,
  serviceInfo,
  serviceRequestPayload,
  serviceTime,
  serviceTransition,
  submitRequest,
  vehicleValue,
  readyToSubmitRescue,
  predictiveETA: predictiveETAReducer,
  urlShortener: urlShortenerReducer,
  warrantyDeflection: warrantyDeflectionReducer,
});

export default baseReducer;

export type RootState = ReturnType<typeof baseReducer>;
